import { render, staticRenderFns } from "./DaftarPegawai.vue?vue&type=template&id=6b9522fb&scoped=true"
import script from "./DaftarPegawai.vue?vue&type=script&lang=js"
export * from "./DaftarPegawai.vue?vue&type=script&lang=js"
import style0 from "./DaftarPegawai.vue?vue&type=style&index=0&id=6b9522fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9522fb",
  null
  
)

export default component.exports